/**
 * 模式配置相关API
 * 处理获取和管理AI模式配置的函数
 */

import axiosInstance from "../services/axiosConfig";
import { API_PATHS, STORAGE_KEYS } from "./config";
import { getCurrentUser } from "./utils";
import Logger from "../utils/logger";

const isValidModeConfigList = (value) =>
  Array.isArray(value) && value.some((item) => item && typeof item.key === "string");

export const getCachedModeConfigs = () => {
  try {
    const cached = JSON.parse(localStorage.getItem(STORAGE_KEYS.MODE_CONFIGS) || "null");
    return isValidModeConfigList(cached) ? cached : [];
  } catch (error) {
    Logger.warn("读取模式配置缓存失败", error);
    return [];
  }
};

/**
 * 获取所有可用的模式配置
 * @returns {Promise} 包含模式配置列表的Promise
 */
export const getModeConfigs = async () => {
  const response = await axiosInstance.get(
    `${API_PATHS.BASE_API_URL}${API_PATHS.MODE.GET_PUBLIC_CONFIGS}`
  );

  if (response?.success && isValidModeConfigList(response.data)) {
    try {
      localStorage.setItem(STORAGE_KEYS.MODE_CONFIGS, JSON.stringify(response.data));
    } catch (error) {
      Logger.warn("写入模式配置缓存失败", error);
    }
  }

  return response;
};

/**
 * 更新模式配置缓存
 * 当后台修改配置后，可以调用此函数刷新前端缓存
 */
export const refreshModeConfigs = async () => {
  try {
    // 清除本地缓存
    localStorage.removeItem(STORAGE_KEYS.MODE_CONFIGS);

    // 重新获取配置
    return await getModeConfigs();
  } catch (error) {
    Logger.error("刷新模式配置异常", error);
    return { success: false, message: `刷新模式配置出错: ${error.message}` };
  }
};
